module.exports = __webpack_public_path__ + "img/start-blur.4fe319df.jpg";